module.exports = __webpack_public_path__ + "img/7beb967.png";